/*
 * Copyright (c) 2021. FINN Sp. z o.o.
 */

package pl.finn.forms.generator

import io.kvision.navigo.Navigo
import io.kvision.routing.Routing
import pl.finn.forms.App
import pl.finn.forms.utils.stringProperty

fun Routing.formRouting(app: App): Navigo {
  return on("/formularz_nowy/:token", { params ->
    DocumentFormModel.createNewForm(stringProperty(params, "token"), app)
  }).on("/formularz_edycja/:token", { params ->
    DocumentFormModel.editForm(stringProperty(params, "token"), app)
  })
}